import { BaseComponent } from "./base";

export class InputArea extends BaseComponent {
  private placeholder: string;
  private onSend: (content: string) => void;
  private inputEl!: HTMLTextAreaElement;
  private sendBtn!: HTMLButtonElement;
  private disabled = false;

  constructor(placeholder: string, onSend: (content: string) => void) {
    super();
    this.placeholder = placeholder;
    this.onSend = onSend;
    this.element = this.create();
    this.initEvents();
  }

  protected create(): HTMLElement {
    const form = document.createElement("form");
    form.className = "ac-input-wrap";

    this.inputEl = document.createElement("textarea");
    this.inputEl.className = "ac-input-field";
    this.inputEl.rows = 1;
    this.inputEl.placeholder = this.placeholder;
    this.inputEl.setAttribute("aria-label", "Message");

    this.sendBtn = document.createElement("button");
    this.sendBtn.type = "submit";
    this.sendBtn.className = "ac-send-btn";
    this.sendBtn.setAttribute("aria-label", "Send message");
    this.sendBtn.innerHTML = this.iconSend();

    form.appendChild(this.inputEl);
    form.appendChild(this.sendBtn);
    return form;
  }

  private iconSend(): string {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
    </svg>`;
  }

  private iconLoading(): string {
    return `<svg class="ac-spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
      <path d="M12 2a10 10 0 0 1 10 10"/>
    </svg>`;
  }

  private initEvents(): void {
    // Auto-resize textarea
    this.inputEl.addEventListener("input", () => {
      this.inputEl.style.height = "auto";
      this.inputEl.style.height = Math.min(this.inputEl.scrollHeight, 120) + "px";
    });

    this.inputEl.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        if (!this.disabled) {
          this.element.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        }
      }
    });

    this.element.addEventListener("submit", (e) => {
      e.preventDefault();
      if (this.disabled) return;
      const value = this.inputEl.value.trim();
      if (!value) return;
      this.inputEl.value = "";
      this.inputEl.style.height = "auto";
      this.onSend(value);
    });
  }

  public setLoading(loading: boolean): void {
    this.disabled = loading;
    this.inputEl.disabled = loading;
    this.sendBtn.disabled = loading;
    this.sendBtn.innerHTML = loading ? this.iconLoading() : this.iconSend();
    this.sendBtn.classList.toggle("ac-send-loading", loading);
  }

  public focus(): void {
    this.inputEl.focus();
  }
}
